<template>
    <div>
        <input class="form-control" type="text" v-model="value" :id="question.QuestionID" :required="question.QuestionRequired" ref="test">
        <label class="form-label" :for="question.QuestionID">{{ question.QuestionText }}</label>
    </div>
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            default: function(data={}) {
                return {
                    QuestionID: data.QuestionID,
                    QuestionNumber: data.QuestionNumber,
                    QuestionRequired: data.QuestionRequired,
                    QuestionText: data.QuestionText,
                    ListOptions: data.ListOptions,
                };
            },
        },
    },

    updated() {
        this.$emit('input', this.value);
    },

    data() {
        return {
            value: '',
        };
    },
}
</script>